// extracted by mini-css-extract-plugin
export default {"wrapper":"PositionsCompatibility_wrapper__PAheq","card":"PositionsCompatibility_card__SGZw2","tag":"PositionsCompatibility_tag__VCBs6","title":"PositionsCompatibility_title__JL4nn"};